export default __webpack_public_path__ + "static/media/SanFrancisco.5eb64308.jpg";